import {Map as MapBase, Route} from '@yandex-delivery/blocks'
import {memo} from 'react'
import {config, isAuthMode} from 'src/shared/config'

import {CourierPlacemark, PointPlacemark, Waypoint} from './components'
import {useController} from './lib'
import {classes} from './Map.classes'
import {MapWithTheme} from './MapWithTheme'
import type {BaseUIProps, Props} from './model'

const MapBaseUI: React.FC<BaseUIProps> = props => {
  const {
    bubbleText,
    mapLocation,
    margin,
    performer,
    placemarkCoordinates,
    routeCoordinates,
    onLoadBoundsSuccess,
    onLoadBoundsError,
    waypointsCoordinates,
    theme,
  } = props

  const mapContent = (
    <>
      {placemarkCoordinates && <PointPlacemark coords={placemarkCoordinates} />}

      {routeCoordinates.length > 0 && (
        <Route onBoundsChange={onLoadBoundsSuccess} onError={onLoadBoundsError} points={routeCoordinates} />
      )}

      {performer && <CourierPlacemark bubbleText={bubbleText} performer={performer} />}

      {waypointsCoordinates.length > 0 &&
        waypointsCoordinates.map(point => <Waypoint coords={point} key={point.toString()} />)}
    </>
  )

  return (
    <div className={classes.container}>
      {isAuthMode ? (
        <MapWithTheme brand={config.brand} lang={config.mapLang} location={mapLocation} margin={margin} theme={theme}>
          {mapContent}
        </MapWithTheme>
      ) : (
        <MapBase brand={config.brand} lang={config.mapLang} location={mapLocation} margin={margin}>
          {mapContent}
        </MapBase>
      )}
    </div>
  )
}

// biome-ignore lint/suspicious/noShadowRestrictedNames: компонент карты, глобальный Map в модуле не нужен
const Map: React.FC<Props> = props => {
  const baseUIProps = useController(props)

  return <MapBaseUI {...baseUIProps} />
}

export default memo(Map)
